module.exports = __webpack_public_path__ + "img/frooto LOGO.7cb256f0.jpg";